/* eslint-disable react-refresh/only-export-components -- context module exports useAuth */
import { createContext, useContext, useState, useEffect } from 'react'

const AUTH_KEY = 'misslemon_auth'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(null)

  useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_KEY)
      if (raw) {
        const { token: t, user: u } = JSON.parse(raw)
        if (t && u) {
          setToken(t)
          setUser(u)
        }
      }
    } catch {
      localStorage.removeItem(AUTH_KEY)
    }
  }, [])

  const login = (newToken, newUser) => {
    setToken(newToken)
    setUser(newUser)
    localStorage.setItem(AUTH_KEY, JSON.stringify({ token: newToken, user: newUser }))
  }

  const logout = () => {
    setToken(null)
    setUser(null)
    localStorage.removeItem(AUTH_KEY)
  }

  const value = {
    user,
    token,
    isAuthenticated: !!token,
    login,
    logout,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
